import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthSelector } from 'Services/auth.service';
import { LOGIN } from 'Features/routePaths';

const PrivateApp = React.lazy(() => Promise.all([import('./PrivateApp')]).then(([comp]) => comp));

export function PrivateNavigate() {
  const isAuth = useSelector(isAuthSelector);
  const location = useLocation();

  if (!isAuth) return <Navigate to={LOGIN} state={{ from: location.pathname }} />;
  return (
    <PrivateApp />
  );
}
export default PrivateNavigate;
